export const LOAD_PRODUCT_SELECTION_DATA_STARTED = "LOAD_PRODUCT_SELECTION_DATA_STARTED";
export const LOAD_PRODUCT_SELECTION_DATA_SUCCESS = "LOAD_PRODUCT_SELECTION_DATA_SUCCESS";
export const LOAD_PRODUCT_SELECTION_DATA_FAILED = "LOAD_PRODUCT_SELECTION_DATA_FAILED";
export const COMPUTE_OFFER_PRODUCTS_MAX_RESIDUAL_VALUE_STARTED = "COMPUTE_OFFER_PRODUCTS_MAX_RESIDUAL_VALUE_STARTED";
export const COMPUTE_OFFER_PRODUCTS_MAX_RESIDUAL_VALUE_SUCCEEDED =
  "COMPUTE_OFFER_PRODUCTS_MAX_RESIDUAL_VALUE_SUCCEEDED";
export const COMPUTE_OFFER_PRODUCTS_MAX_RESIDUAL_VALUE_FAILED = "COMPUTE_OFFER_PRODUCTS_MAX_RESIDUAL_VALUE_FAILED";
export const SIMULATIONS_FILTERS_MODIFIED = "SIMULATIONS_FILTERS_MODIFIED";
export const SIMULATIONS_RECOMPUTE_SUCCEEDED = "SIMULATIONS_RECOMPUTE_SUCCEEDED";
export const SIMULATIONS_RECOMPUTE_FAILED = "SIMULATIONS_RECOMPUTE_FAILED";
export const SIMULATIONS_RECOMPUTE_STARTED = "SIMULATIONS_RECOMPUTE_STARTED";
export const SIMULATIONS_SELECTION_SUCCEEDED = "SIMULATIONS_SELECTION_SUCCEEDED";
export const SIMULATIONS_SELECTION_FAILED = "SIMULATIONS_SELECTION_FAILED";
export const SIMULATIONS_SELECTION_STARTED = "SIMULATIONS_SELECTION_STARTED";
export const FAVORITE_PRODUCT_STARTED = "FAVORITE_PRODUCT_STARTED";
export const FAVORITE_PRODUCT_SUCCEEDED = "FAVORITE_PRODUCT_SUCCEEDED";
export const FAVORITE_PRODUCT_FAILED  = "FAVORITE_PRODUCT_FAILED ";
export const DELETE_PRODUCT_STARTED = "DELETE_PRODUCT_STARTED";
export const DELETE_PRODUCT_SUCCEEDED = "DELETE_PRODUCT_SUCCEEDED";
export const DELETE_PRODUCT_FAILED  = "DELETE_PRODUCT_FAILED ";

export const FINANCIAL_PRODUCT_ADD_FAILED = "FINANCIAL_PRODUCT_ADD_FAILED";
export const FINANCIAL_PRODUCT_ADD_SUCCEEDED = "FINANCIAL_PRODUCT_ADD_SUCCEEDED";
export const FINANCIAL_PRODUCTS_TO_ADD_RETRIEVAL_SUCCEEDED = "FINANCIAL_PRODUCTS_TO_ADD_RETRIEVAL_SUCCEEDED";
export const FINANCIAL_PRODUCTS_TO_ADD_RETRIEVAL_FAILED = "FINANCIAL_PRODUCTS_TO_ADD_RETRIEVAL_FAILED";

export const SET_FINANCIAL_PRODUCTS_VIEW_MODE = "SET_FINANCIAL_PRODUCTS_VIEW_MODE";

